import { cloneProviderClient, unwrap } from './cloneProviderClient';

export async function listProviders(params = {}) {
  const response = await cloneProviderClient.get('/admin/providers', { params });
  return unwrap(response);
}

export async function testProvider(providerId) {
  const response = await cloneProviderClient.post(`/admin/providers/${encodeURIComponent(providerId)}/test`);
  return unwrap(response);
}

export async function resetProvider(providerId) {
  const response = await cloneProviderClient.post(`/admin/providers/${encodeURIComponent(providerId)}/reset`);
  return unwrap(response);
}

export async function createResetLastDieRequest(filters) {
  const response = await cloneProviderClient.post('/admin/providers/reset-last-die-requests', null, { params: filters });
  return unwrap(response);
}

export async function cancelResetLastDieRequest(token) {
  const response = await cloneProviderClient.post(`/admin/providers/reset-last-die-requests/${encodeURIComponent(token)}/cancel`);
  return unwrap(response);
}

export async function confirmResetLastDieRequest(token) {
  const response = await cloneProviderClient.post(`/admin/providers/reset-last-die-requests/${encodeURIComponent(token)}/confirm`);
  return unwrap(response);
}

const providersService = {
  listProviders,
  testProvider,
  resetProvider,
  createResetLastDieRequest,
  cancelResetLastDieRequest,
  confirmResetLastDieRequest,
};
export default providersService;
